import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { MprcCardHeaderColor, MprcJoinComponents } from "components";
import { ButtonClose } from "components/buttons";
import { ButtonRetry } from "components/buttons/ButtonRetry";
import { MprcContainer } from "components/MprcContainer";
import { ExtractErrorInformation, MprcRequestError } from "components/MprcRequestErrorReport";
import { MprcText } from "components/MprcText";
import HtmlUtils from "lib/HtmlUtils";
import LibUtils from "lib/LibUtils";
import * as React from "react";
import { useEffect, useState } from "react";

interface IProps {
    title?: string;
    error?: MprcRequestError;
    action?: React.ReactNode;
    onRetry?: () => void;
    onClose: () => void;
}

const ErrorTitle: React.FC<{ title?: string; status?: number; }> = ({ title, status }) => {
    var msg = title != undefined
        ? title
        : "An error has occurred";

    return <span>{msg}</span>;
};

export const MprcRequestErrorDialog: React.FC<IProps> = (props) => {
    const { title, error } = props;
    const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);

    useEffect(() => {
        buttonRef?.focus();
    }, [buttonRef]);

    //////////////////////////////////////////

    if (error == undefined)
        return null;

    const e = ExtractErrorInformation(error);
    const debug = HtmlUtils.isLocalhost();
    const message =
        (e.errorList && Object.keys(e.errorList).length > 0)
            ? (
                <ul>
                    {
                        Object.values(e.errorList).map((item) => {
                            return item.map((x) => (<li>{x}</li>));
                        })
                    }
                </ul>
            )
            : (
                <div>
                    <MprcContainer>
                        <MprcText color={["muted", "dark"]}>
                            {e.message && <p><MprcJoinComponents components={LibUtils.splitByNewLine(e.message)} separator={<br />} /></p>}
                        </MprcText>
                    </MprcContainer>

                    {
                        e.traceIdentifier &&
                        <MprcContainer margin="dense">
                            <MprcText color="muted">
                                <small>Tracker ID: <b>{e.traceIdentifier}</b></small>
                            </MprcText>
                        </MprcContainer>
                    }

                    {
                        debug && e.stackTrace &&
                        <details>
                            <summary>Stack Trace</summary>
                            <div style={{ whiteSpace: "pre", marginTop: 20 }}>
                                <code>{e.stackTrace}</code>
                            </div>
                        </details>
                    }
                </div>
            );

    //////////////////////////////////////////

    return (
        <Dialog
            open
            role="dialog"
            sx={{ zIndex: (theme) => theme.zIndex.tooltip + 1 }}
            maxWidth="md"
            onClose={(e, reason) => reason == "escapeKeyDown" && props.onClose()}
        >
            <MprcCardHeaderColor
                color="error"
                title={<ErrorTitle title={title ?? e.title} status={e.status} />}
            />

            <DialogContent>
                <Typography variant="body1" component="div">
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center" }}>
                {
                    e.status == 423 && props.onRetry &&
                    <ButtonRetry variant="contained" onClick={props.onRetry} />
                }
                <ButtonClose ref={setButtonRef} variant="contained" onClick={props.onClose} />
            </DialogActions>
        </Dialog >
    );
};
